var _style, _circle, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicOrgIcn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#999999;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 25,
    cy: 25,
    r: 25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25,2c12.7,0,23,10.3,23,23S37.7,48,25,48S2,37.7,2,25S12.3,2,25,2z M25,50c13.8,0,25-11.2,25-25S38.8,0,25,0 S0,11.2,0,25S11.2,50,25,50z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.9,28.5c-2.9,2.9-6.8,4.4-10.9,4.4c-4.1,0-8-1.6-10.9-4.4L10.5,25l3.5-3.5c2.9-2.9,6.8-4.4,10.9-4.4 c4.1,0,8,1.6,10.9,4.4l3.6,3.6L35.9,28.5z M36.6,20.7C33.5,17.7,29.4,16,25,16c-4.4,0-8.5,1.7-11.7,4.7L9,25l4.4,4.3 C16.5,32.3,20.6,34,25,34c4.4,0,8.5-1.7,11.7-4.7L41,25L36.6,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25,22.3c-1.5,0-2.7,1.2-2.7,2.6c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5c0-2,1.7-3.7,3.8-3.7 c0.3,0,0.6,0.2,0.6,0.5C25.5,22.1,25.3,22.3,25,22.3z M25,18.1c-3.9,0-7,3.1-7,6.9s3.2,6.9,7,6.9c3.9,0,7-3.1,7-6.9 S28.9,18.1,25,18.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicOrgIcn);
export default __webpack_public_path__ + "static/media/public_org_icn.041a20c67e9ffae8b0ed930d3d80f43e.svg";
export { ForwardRef as ReactComponent };